<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	export let href: string;
	export let label: string;
	let className: string = '';
	export { className as class };
</script>

<a
	data-sveltekit-reload
	class={twMerge(
		'flex h-[68px] w-full items-center justify-center rounded-[7px] bg-primary text-center text-sm font-semibold',
		className
	)}
	{href}
>
	{label}
</a>
